<template>
  <div id="library-content" style="width: 100%"></div>
</template>

<script>
import { start } from 'qiankun'
import { registerApps } from './config/index'
import common from "@common/common";
import { mapGetters } from 'vuex'

export default {
  name: 'previewLibrary',
  computed: {
    ...mapGetters('unifiedContentLibrary', ['getContentInstance']),
    contentInstance(){
      return this.getContentInstance
    }
  },
  created() {
    const str = this.$route.hash
    const urlPath = this.$route.path
    if (str) {
      const url = decodeURIComponent(str)
      const index = url.indexOf('，')
      let path = ''
      if(index === -1){
        path = url.substring(2)
      }else {
        path = url.substring(2, index)
      }
      window.location.replace(urlPath + path)
    }
  },
  mounted() {
    if (!window.qiankunStartedPreview) {
      window.qiankunStartedPreview = true

      const parentInstance = {
        uploadClick: ()=>{
          this.$store.dispatch('unifiedContentLibrary/uploadBtnClick')
        },
        getUserKeys: ()=>{
          return common.userKeys()
        },
        getCommon: ()=>{
          return common
        },
        registerContentInstance: (instance)=>{
          this.$store.dispatch('unifiedContentLibrary/setContentInstance', {...this.contentInstance, ...instance})
        },
        updateUploadList: (list)=>{
          this.$store.dispatch('unifiedContentLibrary/setUploadList', list)
        },
        updateUploadStatus: (data)=>{
          this.$store.dispatch('unifiedContentLibrary/setUploadStatus', data)
        },
        toggleUploadModal: (val)=>{
          this.$store.dispatch('unifiedContentLibrary/setIsShowUploadModal', val)
        },
        setDetailInfo: (data, bool)=>{
          this.$store.dispatch('unifiedContentLibrary/setIsDetail', bool)
          this.$store.dispatch('unifiedContentLibrary/setDetailInfo', data)
        },
        getSystemConfig: ()=>{
          return this.$_syscfg
        },
        getThis: ()=>{
          return this
        }
      }

      registerApps(parentInstance,'/previewLibrary')
      start({
        prefetch: false,
        sandbox: {
          experimentalStyleIsolation: false // 样式隔离
        }
      })

    }
  }

}
</script>

<style lang="less" scoped>
.preview-library {
  width: 100%;
  height: 100vh;
}
</style>
